import * as React from 'react';
import { AccordionContext } from './AccordionContext';
import { AccordionContextProps } from './AccordionContext.types';

export const useAccordionContext = () => React.useContext<AccordionContextProps>(AccordionContext);

